module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row well"
  }, [_vm._l((_vm.columns), function(col) {
    return _c('div', {
      key: col.index,
      staticClass: "col-md-3"
    }, [_c('ul', {
      staticStyle: {
        "padding-left": "0px"
      },
      attrs: {
        "type": "none"
      }
    }, _vm._l((_vm.splits[col]), function(field) {
      return _c('li', {
        key: field.index
      }, [_c('div', {
        staticClass: "checkbox checkbox-inline"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.selectedList),
          expression: "selectedList"
        }],
        attrs: {
          "type": "checkbox",
          "disabled": _vm.readonly,
          "id": _vm.name + field[_vm.fieldName] + _vm.suffix
        },
        domProps: {
          "value": field[_vm.fieldName],
          "checked": Array.isArray(_vm.selectedList) ? _vm._i(_vm.selectedList, field[_vm.fieldName]) > -1 : (_vm.selectedList)
        },
        on: {
          "change": function($event) {
            var $$a = _vm.selectedList,
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = field[_vm.fieldName],
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.selectedList = $$a.concat([$$v]))
              } else {
                $$i > -1 && (_vm.selectedList = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
              }
            } else {
              _vm.selectedList = $$c
            }
          }
        }
      }), _vm._v(" "), _c('label', {
        attrs: {
          "for": _vm.name + field[_vm.fieldName] + _vm.suffix
        }
      }, [_vm._v(_vm._s(field.description))])])])
    }))])
  }), _vm._v(" "), (_vm.isDebug) ? _c('div', [_vm._v("\n        " + _vm._s(_vm.selectedList) + "\n    ")]) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bfeaa2ec"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CheckBoxPanel.vue
// module id = 991
// module chunks = 1